<section id="content">

    <form id="form">
        <div class="row">
            <div class="col-md-12 col-xs-12 table-cont">

                <div class="form-group">
                    <div class="card">
                        <div class="card-title">
                            <h2>Order</h2>
                        </div>

                        <div class="cont">
                            <div class="group">
                                <div class="collapse-title">
                                    Order
                                    <i class="collapse-icon fa"></i>
                                </div>

                                <div class="table-responsive">
                                    <p-table #dt1 class="table" styleClass="ui-table-customers"
                                        tableStyleClass="table table-responsive" [value]="tableData" [rows]="10"
                                        [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true" scrollHeight="400px"
                                        [frozenHeader]="true"
                                        [resizableColumns]="true" [loading]="loading" [paginator]="true">
                                        <ng-template pTemplate="caption">
                                            <div class="flex" style="float: left;">
                                                <p-button
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write"
                                                    label="Add Order" [outlined]="true" icon="pi pi-plus-circle"
                                                    (onClick)="showDialog()"></p-button>
                                            </div>

                                            <div style="text-align: right">
                                                <button type="button" pButton icon="pi pi-file-excel" iconPos="left"
                                                    label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;"
                                                    class="ui-button-success"></button>
                                                <button type="button" pButton icon="pi pi-file-pdf" iconPos="left"
                                                    label="PDF" (click)="exportPdf()"
                                                    class="ui-button-warning"></button>
                                            </div>
                                        </ng-template>

                                        <!-- <ng-template pTemplate="caption">

                                </ng-template> -->
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th width="10%">
                                                    #
                                                </th>
                                                <th pSortableColumn="orderNumber" width="15%">
                                                    <div class="flex align-items-center">
                                                        Order Number
                                                        <p-sortIcon field="orderNumber"></p-sortIcon>
                                                    </div>
                                                </th>


                                                <th pSortableColumn="customerName" width="20%">
                                                    <div class="flex align-items-center">
                                                        Customer
                                                        <p-sortIcon field="customerName"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="salesOrder" width="15%">
                                                    <div class="flex align-items-center">
                                                        Sales Order
                                                        <p-sortIcon field="salesOrder"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="orderDate" width="20%">
                                                    <div class="flex align-items-center">
                                                        Order Date
                                                        <p-sortIcon field="orderDate"></p-sortIcon>
                                                    </div>
                                                </th>

                                               
                                                <th pSortableColumn="expectedDeliveryDate" width="20%">
                                                    <div class="flex align-items-center">
                                                        Expected Order Delivery Date
                                                        <p-sortIcon field="expectedDeliveryDate"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th pSortableColumn="creatorName" width="7%">
                                                    <div class="flex align-items-center">
                                                        Created By
                                                        <p-sortIcon field="creatorName"></p-sortIcon>
                                                    </div>
                                                </th>

                                                <th width="15%" alignFrozen="right" pFrozenColumn
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                                                    <div class="flex align-items-center">
                                                        Actions
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th></th>

                                                <th>
                                                    <p-columnFilter field="orderNumber" type="text" display="menu"
                                                        placeholder="orderNumber"></p-columnFilter>
                                                </th>


                                                <th>
                                                    <p-columnFilter field="customerName" type="text" display="menu"
                                                        placeholder="Customer"></p-columnFilter>
                                                </th>

                                                <th>
                                                    <p-columnFilter field="salesOrder" type="text" display="menu"
                                                        placeholder="sales Order"></p-columnFilter>
                                                </th>

                                                <th>
                                                    <p-columnFilter field="orderDate" type="date" display="menu"
                                                        placeholder="Order Date"></p-columnFilter>
                                                </th>

                                                <th>
                                                    <p-columnFilter field="expectedDeliveryDate" type="date" display="menu"
                                                        placeholder="Expected Delivery Date"></p-columnFilter>
                                                </th>

                                                <th>
                                                    <p-columnFilter field="creatorName" type="text" display="menu"
                                                        placeholder="Created By"></p-columnFilter>

                                                <th alignFrozen="right" pFrozenColumn
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-data let-i="rowIndex">
                                            <tr>
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ data.orderNumber}}</td>
                                                <td>{{ data.customerName }}</td>
                                                <td>{{ data.salesOrder }}</td>
                                                <td>{{ data.orderDate | date: 'MM/dd/yyyy' }}</td>
                                                <td>{{ data.expectedDeliveryDate | date: 'MM/dd/yyyy' }}</td>
                                                <td>{{ data.creatorName }}</td>
                                                <td alignFrozen="right" pFrozenColumn
                                                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                                                    <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true"
                                                        [text]="true" (onClick)="editeMasterOrder(data.id)"
                                                        pTooltip="Edit Order"></p-button>



                                                    <p-button icon="pi pi-eye" class="mr-2" [rounded]="true"
                                                        [text]="true" [outlined]="true"
                                                        (onClick)="openItemsDialog(data.id)" pTooltip="Order Items"
                                                        tooltipPosition="top"></p-button>
                                                        <p-button

                                                        icon="pi pi-ticket"  [rounded]="true"
                                                        [text]="true"  (onClick)="getDeliveryTickets(data.id)"
                                                        pTooltip="View Tickets"
                                                        [disable]="checkItemTicketExist(data.id)"
                                                        tooltipPosition="top"></p-button>

                                                    <p-button
                                                        *ngIf="(authenticationService.applanceRole.accessLevel || 0) > accessLevelEnum.read_write"
                                                        icon="pi pi-trash" severity="danger" [rounded]="true"
                                                        [text]="true" (onClick)="deleteMasterOrder(data.id)"
                                                        pTooltip="Delete Order" tooltipPosition="top"></p-button>




                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="9">No Order Found.</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</section>

<p-toast></p-toast>

<!--Create Or Update Order-->

<p-dialog [header]="dialogTitle" [modal]="true" [(visible)]="visible" [style]="{ width: '95%', height: '85%' }"
    styleClass="custom-dialog"
    [maximizable]="true">
  

    <div class="dialog-content">
        <div class="column">

            <div class="form-group">
                <label for="count">Order Number</label>
                <input pInputText id="count" [(ngModel)]="orderNumberMasterOrder" placeholder="Enter Order Number"
                    class="full-width" />
            </div>

            <div class="form-group">
                <label for="count">Sales Order Number</label>
                <input pInputText id="count" [(ngModel)]="salesOrderNumberMasterOrder" placeholder="Enter Sales Order Number"
                    class="full-width" />
            </div>

            <div class="form-group">
                <label for="price">Order Date</label>
                <p-calendar id="OrderDate" [defaultDate]="today" [(ngModel)]="orderDateMasterOrder" [showIcon]="true"
                    [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Order Date"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    class="full-width"></p-calendar>
            </div>


        </div>


        <div class="column">

            <div class="form-group">
                <label for="customer">Customer Number - Customer Name</label>
                <p-dropdown id="customer" [options]="customerOptions" placeholder="Select Customer"
                    optionLabel="customerName" optionValue="customerId" class="full-width"
                    [(ngModel)]="selectedCustomerMasterOrder" [virtualScroll]="true" [lazy]="true" [filter]="true"
                    filterBy="customerNumber,customerName" [virtualScrollItemSize]="38" [showClear]="true"
                    (onLazyLoad)="loadCustomersLazy($event)" (onChange)="customerChange($event)">

                    <ng-template let-option pTemplate="selectedItem">
                        <div class="item">
                            <span id="{{option.customerId}}">{{option.customerNumber + ' - ' + option.customerName}}</span>
                        </div>
                    </ng-template>

                    <ng-template let-option pTemplate="item">
                        <span id="{{option.customerId}}">{{option.customerNumber + ' - ' + option.customerName}}</span>
                    </ng-template>

                </p-dropdown>

            </div>

            <div style="margin: 4px;"></div>

            <div class="form-group">
                <label for=" ProvisionValue"> Created By</label>
                <p-dropdown [options]="UserOptions" class="full-width" filter="true" name="sssOwnerName" required
                [(ngModel)]="selectedOrderCreatorIdMasterOrder" placeholder="Select..." [showClear]="true" 
                optionValue="userId" optionLabel="fullName">
                <ng-template let-option pTemplate="selectedItem">
                    <div class="item">
                        <div>{{option.fullName}}</div>
                    </div>
                </ng-template>
                <ng-template let-option pTemplate="item">
                    <span id="{{option.userId}}">{{option.fullName}}</span>
                </ng-template>
            </p-dropdown>
                




            </div>

            <div class="form-group">
                <label for="price">Expected Order Delivery Date</label>
                <p-calendar id="OrderDate" [defaultDate]="today" [(ngModel)]="expectedDeliveryDateMasterOrder" [showIcon]="true"
                    [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Expected Delivery Date"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    class="full-width"></p-calendar>
            </div>
        </div>
    </div>

    <!-- Products Tables-->


    <!-- Product Table Section -->
    <div class="table-section">
           <!-- Add Product Button -->
     <div class="mb-3 gap-3">
        <p-button

        label="Add SBM Order" [outlined]="true" icon="pi pi-plus-circle" [disabled]="!selectedCustomerMasterOrder"
        (onClick)="showProductItemsDialog()"></p-button>

        <p-button style="margin-left: 12px;" label=" Add Customer Order"   icon="pi pi-plus-circle"  [disabled]="!selectedCustomerMasterOrder"
        (onClick)="showCustomerProductItemsDialog()" 
        ></p-button>
    </div>
        <p-table [value]="productItemsDisplay"  class="p-datatable-sm"
        [scrollable]="true" scrollHeight="250px"
        [resizableColumns]="true">

            <ng-template pTemplate="header">
                <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Item</th>
                    <th>Opportunity</th>
                    <th>Batch No.</th>
                    <th>Module</th>
                    <th>Count</th>
                    <th>Price</th>
                    <th>Sales Order Item</th>
                    <th>Provision Value</th>
                    <th>Coverage Start</th>
                    <th>Coverage End</th>
                    <th>Delta</th>
                    <th alignFrozen="right" pFrozenColumn>Actions</th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-i="rowIndex">
                <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.productCategory }}</td>
                    <td>{{ row.productType }}</td>
                    <td>{{ row.productItem }}</td>
                    <td>{{ row.opportunityName }}</td>
                    <td>{{ row.batchNumber }}</td>
                    <td>{{ row.moduleName }}</td>
                    <td>{{ row.count }}</td>
                    <td>{{ row.price | currency }}</td>
                    <td>{{ row.salesOrderItem }}</td>
                    <td>{{ row.provisionValue }}</td>
                    <td>{{ row.startDate | date: 'MM/dd/yyyy' }}</td>
                    <td>{{ row.converageEnd | date: 'MM/dd/yyyy' }}</td>
                    <td>{{ row.delta }}</td>

                    <td alignFrozen="right" pFrozenColumn
                    *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                    <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true"
                        [text]="true" (onClick)="editeProducrItem(row.id)"
                        pTooltip="Edit Order"></p-button>

                    <p-button
                        *ngIf="(authenticationService.applanceRole.accessLevel || 0) > accessLevelEnum.read_write"
                        icon="pi pi-trash" severity="danger" [rounded]="true"
                        [text]="true" (onClick)="deleteProductItem(row.id)"
                        [disabled]="dialogTitle == 'Add Master Order '"
                        pTooltip="Delete Order" tooltipPosition="top"></p-button>
                </td>



                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10" class="text-center">No products added yet.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>





    <div class="dialog-footer">
        <p-button label="Cancel" severity="secondary"  (onClick)="closeDialog() "></p-button>
        <p-button [label]="buttonTitle" (onClick)="onSave()" [disabled]="productItemsDisplay.length ==0"></p-button>
    </div>
</p-dialog>



<!--Add product to Order-->

<p-dialog [header]="dialogTitleProduct" [modal]="true" [(visible)]="visibleProductItemsDialog"
    [style]="{ width: '90%', height: '80%' }" styleClass="custom-dialog" [maximizable]="true">
    <div class="dialog-content">
        <div class="column">

            <div class="component">
                <app-products-lists [kind]="'all'" [(selectedCategory)]="selectedCategory"
                    [(selectedType)]="selectedType" [(selectedItem)]="selectedItem"
                    [(selectedProductId)]="selectedProductId"
                    (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>

            </div>

            <div class="form-group">
                <label for="count">Count</label>
                <div class="full-width">
                    <p-inputNumber id="count" type="number" [(ngModel)]="count" [max]="maxAvilable" [min]="0"
                        placeholder="Enter Count" [disabled]="!selectedstockId" (ngModelChange)="onCountChange()" />
                    <div *ngIf="selectedstockId !=null " class="text-warning" style="padding-top: 2px;">
                        {{subjectTitle}} {{ maxAvilable }}.
                    </div>

                </div>

            </div>

            <div class="form-group">
                <label for="price">Price</label>
                <p-inputNumber id="price" type="number" [(ngModel)]="price" placeholder="Enter Price" class="full-width"
                    mode="currency" currency="USD" />
                <div *ngIf="(price <= provisionValue ) && provisionValue != null" class="text-warning"
                    style="padding-top: 2px;">
                    The Price s Less Than Or Equal The Provision Value
                </div>
            </div>


            <div class="form-group checkbox-group">
                <label for="hasCoverage">Has Coverage</label>
                <p-checkbox id="hasCoverage" [(ngModel)]="hasCoverage" binary="true"
                    (onChange)="hasCoverageChange()"></p-checkbox>
                <div></div>
            </div>




            <div class="form-group">
                <label for="startDate">Start Date</label>
                <p-calendar id="startDate" [(ngModel)]="startDate" [disabled]="!hasCoverage"
                    [showIcon]="true" [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Start Date"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    class="full-width"></p-calendar>
            </div>
        </div>


        <div class="column">


            <div class="form-group">
                <label for="opp">Opportunity</label>
                <p-dropdown id="opp" [options]="opportunityOptions" placeholder="Select Opportunity" class="full-width"
                    [(ngModel)]="selectedOpportunity"
                    [disabled]="!opportunityOptions || opportunityOptions.length === 0" optionLabel="opportunityName"
                    optionValue="id" (onChange)="opportunityChange()" [showClear]="true"></p-dropdown>
            </div>
            <div class="form-group">
                <label for="stock">Batch Number</label>
                <p-dropdown id="Stock" [options]="stockOptions" placeholder="Select Batch"
                    [(ngModel)]="selectedstockId" [disabled]="stockOptions?.length === 0" optionLabel="batchNumber"
                    optionValue="stockId" class="full-width" (onChange)="stockChange()" [showClear]="true" required>
                    <ng-template let-item pTemplate="item">
                        <div [ngClass]="{'custom-highlight': item.status === 1}">
                            {{item.batchNumber}}
                        </div>
                    </ng-template>
                </p-dropdown>

            </div>



            <div class="form-group">
                <label for="module">Module</label>
                <p-dropdown id="opp" [options]="moduleOptionsCopy" placeholder="Select Module" class="full-width"
                    [(ngModel)]="selectedModule"
                    [disabled]="!moduleOptionsCopy || moduleOptionsCopy.length === 0 || selectedProductId ==null"
                    optionLabel="moduleName" optionValue="id" (onChange)="opportunityChange()"
                    [showClear]="true"></p-dropdown>
            </div>



            <div class="form-group">
                <label for=" ProvisionValue"> Provision Value</label>
                <p-inputNumber id="count" type="number" [(ngModel)]="provisionValue" placeholder="Enter provision Value"
                    class="full-width" readonly mode="currency" currency="USD" />
                <div style="padding-bottom: 4px;"></div>

            </div>

            <div *ngIf="selectedstockId !=null " style="margin: 8px;">
            </div>


            <div class="form-group">
                <label for=" salesOrder"> Sales Order Item</label>
                <input pInputText id="count" type="text" [(ngModel)]="salesOrderItemNumber" placeholder="Enter Sales Order Item"
                    class="full-width"/>
            </div>



            <div *ngIf="(price <= provisionValue ) && provisionValue != null" style="margin: 8px;">
            </div>

            <div class="form-group">
                    <div style="padding: 32px;"></div>
            </div>



            <div class="form-group">
                <label for="endDate">End Date</label>
                <p-calendar id="endDate"  [disabled]=" startDate == null " [(ngModel)]="endDate"
                    [showIcon]="true" [minDate]="startDate" [showButtonBar]="true" icon="pi pi-calendar"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    placeholder="Select End Date" class="full-width"></p-calendar>
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <p-button label="Cancel" severity="secondary" (onClick)="closeProductItemsDialog()"></p-button>
        <p-button label="Save"  (onClick)="saveProductitem()" [disabled]="!productItemValid()"></p-button>
    </div>
</p-dialog>




<!-- Add Customer Product And Stock -->

<p-dialog header="Add Customer Order" [modal]="true" [(visible)]="visibleCustomerProductItemsDialog"
    [style]="{ width: '90%', height: '80%' }" styleClass="custom-dialog" [maximizable]="true">
    <div class="dialog-content">
        <div class="column">

            <div class="component">
                <app-products-lists [kind]="'all'" [(selectedCategory)]="selectedCategory"
                    [(selectedType)]="selectedType" [(selectedItem)]="selectedItem"
                    [(selectedProductId)]="selectedProductId"
                    (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>

            </div>

            <div class="form-group">
                <label for="customerProductCount">Count</label>
                <div class="full-width">
                    <p-inputNumber id="customerProductCount" type="number" [(ngModel)]="customerProductCount" [min]="0"
                        placeholder="Enter Count"  (ngModelChange)="onCustomerPriceOrCountChange()" />
                </div>

            </div>

            <div class="form-group">
                <label for="customerProductPrice">Cost Price</label>
                <p-inputNumber id="customerProductPrice" type="number" [(ngModel)]="customerProductCostPrice" placeholder="Enter Price" class="full-width"
                    mode="currency" currency="USD" (ngModelChange)="onCustomerPriceOrCountChange()" />
            
            </div>


             <div class="form-group">
                <label for=" customerProductprovisionValue"> Provision Value</label>
                <p-inputNumber id="count" type="number" [(ngModel)]="customerProductprovisionValue" placeholder="Enter provision Value"
                    class="full-width" readonly mode="currency" currency="USD" />
                <!-- <div style="padding-bottom: 4px;"></div> -->

            </div>

            <div class="form-group">
                <label for=" PoNumber"> Po. Number</label>
                <p-inputNumber id="PoNumber" type="number" [(ngModel)]="customerProductPONumber" placeholder="Enter Port Number"
                    class="full-width"  />
            </div>



            <div class="form-group checkbox-group">
                <label for="hasCoverage">Has Coverage</label>
                <p-checkbox id="hasCoverage" [(ngModel)]="hasCoverage" binary="true"
                    (onChange)="hasCoverageChange()"></p-checkbox>
                <div></div>
            </div>




            <div class="form-group">
                <label for="startDate">Start Date</label>
                <p-calendar id="startDate" [(ngModel)]="startDate" [disabled]="!hasCoverage"
                    [showIcon]="true" [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Start Date"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    class="full-width"></p-calendar>
            </div>
        </div>


        <div class="column">


            <div class="form-group">
                <label for="opp">Opportunity</label>
                <p-dropdown id="opp" [options]="opportunityOptions" placeholder="Select Opportunity" class="full-width"
                    [(ngModel)]="selectedOpportunity"
                    [disabled]="!opportunityOptions || opportunityOptions.length === 0" optionLabel="opportunityName"
                    optionValue="id"x [showClear]="true"></p-dropdown>
            </div>
            
            <div class="form-group">
                <label for="stock">Batch Number</label>
                <input pInputText id="count" type="text"  [(ngModel)]="customerProductBatchNumber"  placeholder="Enter Stock Batch Number"
                class="full-width"/>

            </div>

            <div class="form-group">
                <label for="stock">Stock Status</label>
               <p-dropdown id= "status" [options]="statusOptions" optionValue="value" optionLabel="label" 
               [(ngModel)]="customerProductStockStatus"  [readonly]="true"
               placeholder="Choose Stock Status"  class="full-width"/>

            </div>
        


            <div class="form-group">
                <label for="module">Module</label>
                <p-dropdown id="opp" [options]="moduleOptionsCopy" placeholder="Select Module" class="full-width"
                    [(ngModel)]="selectedModule"
                    [disabled]="moduleOptionsCopy.length == 0"
                    optionLabel="moduleName" optionValue="id" (onChange)="opportunityChange()"
                    [showClear]="true"></p-dropdown>
            </div>



            <div class="form-group">
                <label for="customerProductPrice">Selling Price</label>
                <p-inputNumber id="customerProductPrice" type="number" [(ngModel)]="customerProductSellingPrice" placeholder="Enter Price" class="full-width"
                    mode="currency" currency="USD"  />
            
            </div>

            <div class="form-group">
                <label for=" salesOrder"> Sales Order Item</label>
                <input pInputText id="count" type="text" [(ngModel)]="salesOrderItemNumber" placeholder="Enter Sales Order Item"
                    class="full-width"/>
            </div>
    
       

             <div class="form-group">
                <label for="PurchaseDate">Purchase Date</label>
                <p-calendar id="Purchase Date"  [(ngModel)]="customerProductStockPurchesDate"
                    [showIcon]="true"  [showButtonBar]="true" icon="pi pi-calendar"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    placeholder="Select Purchase Date" class="full-width"></p-calendar>
            </div>
     
         

       
            <div class="form-group checkbox-group">
                <label for="Rabet">Rabet</label>
                <p-checkbox id="Rabet" [(ngModel)]="customerProductRabet" binary="true"
                   ></p-checkbox>
                <div></div>
            </div>



            <div class="form-group">
                <label for="endDate">End Date</label>
                <p-calendar id="endDate"  [disabled]=" startDate == null " [(ngModel)]="endDate"
                    [showIcon]="true" [minDate]="startDate" [showButtonBar]="true" icon="pi pi-calendar"
                    dateFormat="yy/mm/dd"
                    [utc]="true"
                    placeholder="Select End Date" class="full-width"></p-calendar>
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <p-button label="Cancel" severity="secondary" (onClick)="closeCustomerProductItemsDialog()"></p-button>
        <p-button label="Save"  (onClick)="saveCustomerProductitem()" [disabled]="!customerProductValid()"></p-button>
    </div>
</p-dialog>


<!-- renew Order Dialog -->
<p-dialog header="Renew Subscription" [(visible)]="visibleRenewDialog" [modal]="true" [style]="{ width: '60rem' , height: '80rem' }"
    styleClass="custom-dialog" [closeOnEscape]="true">

    <div class="dialog-content">
        <div class="column">

            <div class="form-group">
                <app-products-lists [kind]="'isLicense'" [(selectedCategory)]="selectedCategory"
                [(selectedType)]="selectedType" [(selectedItem)]="selectedItem"
                       [(selectedProductId)]="selectedProductId"
                        (selectionChanged)="handleSelectionChangedProduct($event)"></app-products-lists>


            </div>


            <div class="form-group">
                <label for="count">Count</label>
                <div class="full-width">
                    <p-inputNumber id="count" type="number" [(ngModel)]="countRenew"
                    [required]="countRenew ==null"
                    [max]="maxAvilable" [min]="0"
                        placeholder="Enter Count" [disabled]="!selectedstockIdRenew" (ngModelChange)="onCountChangeForItemLincese()" />
                    <div *ngIf="selectedstockIdRenew !=null " class="text-warning" style="padding-top: 2px;">
                        {{subjectTitle}} {{ maxAvilable }}.
                    </div>

                </div>

            </div>

            <div class="form-group">
                <label for="price">Price</label>
                <p-inputNumber id="price" type="number" [(ngModel)]="priceRenew"
                [required]="priceRenew ==null"
                placeholder="Enter Price" class="full-width"
                    mode="currency" currency="USD" />
                <div *ngIf="(priceRenew <= provisionValueRenew ) && provisionValueRenew != null" class="text-warning"
                    style="padding-top: 2px;">
                    The Price s Less Than Or Equal The Provision Value
                </div>
            </div>



            <div class="form-group">
                <label for="Order Number">Order Number </label>
                <input pInputText id="count" type="text" [(ngModel)]="orderNumberRenew"
                [required]="orderNumberRenew ==null"
                placeholder="EnterOrder Number"
                    class="full-width"/>
            </div>

            <div class="form-group">
                <label for="count">Sales Order Number</label>
                <input pInputText id="count" [(ngModel)]="salesOrderRenew" [required]="salesOrderRenew ==null"
                 placeholder="Enter Sales Order Number"
                    class="full-width" />
            </div>





            <div class="form-group">
                <label for="startDate">Renew From</label>
                <p-calendar id="startDate" [(ngModel)]="startDateRenew"
                    [required]="startDateRenew ==null"
                    [showIcon]="true" [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Start Date"
                    [minDate]="maxRenewOldDate"
                    class="full-width">
                </p-calendar>
            </div>
        </div>


        <div class="column">


            <div class="form-group">
                <label for="opp">Opportunity</label>
                <p-dropdown id="opp" [options]="opportunityOptions" placeholder="Select Opportunity" class="full-width"
                    [(ngModel)]="selectedOpportunityRenew"
                    [disabled]="!opportunityOptions || opportunityOptions.length === 0" optionLabel="opportunityName"
                    optionValue="id" (onChange)="opportunityChangeForItemLincese()" [showClear]="true"></p-dropdown>
            </div>
            <div class="form-group">
                <label for="stock">Batch Number</label>
                <p-dropdown id="Stock" [options]="stockOptions" placeholder="Select Batch"
                    [(ngModel)]="selectedstockIdRenew" [disabled]="stockOptions?.length === 0" optionLabel="batchNumber"
                    [required]="selectedstockIdRenew ==null"
                    optionValue="stockId" class="full-width" (onChange)="stockChangeForItemLincese()" [showClear]="true">
                    <ng-template let-item pTemplate="item">
                        <div [ngClass]="{'custom-highlight': item.status === 1}">
                            {{item.batchNumber}}
                        </div>
                    </ng-template>
                </p-dropdown>

            </div>



            <div class="form-group">
                <label for="module">Module</label>
                <p-dropdown id="opp" [options]="moduleOptionsCopy" placeholder="Select Module" class="full-width"
                    [(ngModel)]="selectedModuleRenew"
                    [disabled]="!moduleOptionsCopy || moduleOptionsCopy.length === 0 || selectedProductId ==null"
                    optionLabel="moduleName" optionValue="id" (onChange)="opportunityChangeForItemLincese()"
                    [showClear]="true"></p-dropdown>
            </div>



            <div class="form-group">
                <label for=" ProvisionValue"> Provision Value</label>
                <p-inputNumber id="count" type="number" [(ngModel)]="provisionValueRenew" placeholder="Enter provision Value"
                    class="full-width" readonly mode="currency" currency="USD" />

            </div>



            <div *ngIf="selectedstockIdRenew !=null " style="margin: 8px;">
            </div>
                <div class="form-group">
                <label for=" ProvisionValue"> Created By</label>
                <p-dropdown [options]="UserOptions" class="full-width" filter="true" name="sssOwnerName" required
                [(ngModel)]="createdByRenew" placeholder="Select..." [showClear]="true" 
                optionValue="userId" optionLabel="fullName">
                <ng-template let-option pTemplate="selectedItem">
                    <div class="item">
                        <div>{{option.fullName}}</div>
                    </div>
                </ng-template>
                <ng-template let-option pTemplate="item">
                    <span id="{{option.userId}}">{{option.fullName}}</span>
                </ng-template>
            </p-dropdown>


            </div>

            <div *ngIf="(priceRenew <= provisionValueRenew ) && provisionValueRenew != null" style="margin: 8px;">
            </div>


            <div class="form-group">
                <label for=" salesOrder"> Sales Order Item</label>
                <input pInputText id="count" type="text" [(ngModel)]="salesOrderItemNumberRenew" placeholder="Enter Sales Order Item"
                    class="full-width" [required]="salesOrderItemNumberRenew ==null"/>
            </div>

            <div class="form-group">
                <label for="price">Order Date</label>
                <p-calendar [required]="orderDateRenew ==null" id="OrderDate" [defaultDate]="today" [(ngModel)]="orderDateRenew" [showIcon]="true"
                    [showButtonBar]="true" icon="pi pi-calendar" placeholder="Select Order Date"
                    class="full-width"></p-calendar>
            </div>



            <div class="form-group">
                <label for="endDate">Renew To</label>
                <p-calendar [required]="endDateRenew == null" id="endDate" [defaultDate]="today" [disabled]=" startDateRenew == null " [(ngModel)]="endDateRenew"
                    [showIcon]="true" [minDate]="startDateRenew" [showButtonBar]="true" icon="pi pi-calendar"
                    placeholder="Select End Date" class="full-width"></p-calendar>
            </div>

        </div>



    </div>

    <!-- Footer Buttons -->
    <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end gap-3 dialog-footer">
            <button type="button" class="btn btn-secondary" (click)="closeRenewOrdersDialog()">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="saveRenewOrdersDates()"
            [disabled]="checkRenewData()">
                Save
            </button>
        </div>
    </ng-template>
</p-dialog>




<!-- Order items -->
<!--
<p-dialog header="Edit Order Items" [(visible)]="visibleitemsDialog" [modal]="true" [style]="{ width: '70vw' }">
    <p-table [value]="orderItems" editable="true">
        <ng-template pTemplate="header">
            <tr>
                <th>#</th>
                <th pEditableColumn field="serialNumber">Serial Number</th>
                <th pEditableColumn field="itemPurchaseDate">Purchase Date</th>
                <th pEditableColumn field="itemExpiryDate">Expiry Date</th>
                <th>Order Numbers</th>
                <th>Opportunity Name</th>
                <th>Customer Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
                <td>{{ i + 1 }}</td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText [(ngModel)]="item.serialNumber" placeholder="Enter Serial number" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <span *ngIf="!item.serialNumber" class="placeholder-text">Enter Serial number</span>
                            <span *ngIf="item.serialNumber">{{ item.serialNumber }}</span>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-calendar [(ngModel)]="item.itemPurchaseDate" appendTo="body" dateFormat="yy-mm-dd"
                                placeholder="Enter Purchase Date"></p-calendar>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item.itemPurchaseDate | date: 'yyyy-MM-dd' }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-calendar [(ngModel)]="item.itemExpiryDate" appendTo="body" dateFormat="yy-mm-dd"
                                placeholder="Enter Expiry Date"></p-calendar>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item.itemExpiryDate | date: 'yyyy-MM-dd' }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td>{{ item.orderNumbers?.join(', ') ?? 'No Orders' }}</td>
                <td>{{ item.opportunityName ?? 'No Opportunity' }}</td>
                <td>{{ item.customerName ?? 'No Customer' }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="dialog-footer">
        <p-button label="Cancel" icon="pi pi-times" (onClick)="visibleitemsDialog = false"></p-button>
        <p-button label="Save" icon="pi pi-check" (onClick)="visibleitemsDialog= false"></p-button>
    </div>
</p-dialog> -->


<p-dialog header="Order Items" [(visible)]="visibleitemsDialog" [modal]="true" [style]="{ width: '80vw' }"
    [maximizable]="true" [closable]="false">

    <p-table [value]="orderItems" editable="true"  [(selection)]="selectedProducts"
    [scrollable]="true" scrollHeight="900px"
    [resizableColumns]="true">

        <ng-template pTemplate="caption">

            <p-button icon="pi pi-refresh" class="mr-2" [rounded]="true"
            label="Renew Orders"
            [text]="true" (onClick)="openRenewOrdersDialog()" [disabled]="ckeckSelectedItems()"
            pTooltip="Renew Order" tooltipPosition="top"></p-button>


            <p-button icon="pi pi-plus-circle" class="mr-2" [rounded]="true"
            label="New Delivery"

            [disabled]="ckeckSelectedStockForTicketing() || selectedProducts.length === 0"
            (onClick)= "openNewDeliveryDialog()"
            pTooltip="New Delivery" tooltipPosition="top"></p-button>

        </ng-template>

        <ng-template pTemplate="header">

            <tr>
                <th></th>
                <th>#</th>
                <th field="serialNumber">Serial Number</th>
                <th>Product</th>
                <th field="itemPurchaseDate">Coverage Start</th>
                <th field="itemExpiryDate">Coverage End</th>
                <th field="sellingPrice">Selling Price</th>
                <th field="costPrice">Cost Price</th>

                <th>Order Number</th>
                <th>Opportunity Name</th>
                <th>Customer Name</th>
             
                <th>Is License</th>
                <th alignFrozen="right" pFrozenColumn>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
                <td>
                    <p-tableCheckbox [value]="item" />
                </td>

                <td>{{ i + 1 }}</td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText [(ngModel)]="item.serialNumber" placeholder="Enter Serial number" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <span *ngIf="!item.serialNumber" class="placeholder-text">Enter Serial number</span>
                            <span *ngIf="item.serialNumber">{{ item.serialNumber }}</span>
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td>{{item.productCategory + ' - '}} {{item.productType + ' - '}} {{item.productItem}}</td>


                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-calendar [(ngModel)]="item.itemPurchaseDate" appendTo="body" dateFormat="yy-mm-dd"
                                placeholder="Enter Purchase Date"></p-calendar>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item.itemPurchaseDate | date: 'MM/dd/yyyy' }}
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-calendar [(ngModel)]="item.itemExpiryDate" appendTo="body" dateFormat="yy-mm-dd"
                                placeholder="Enter Expiry Date"></p-calendar>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item.itemExpiryDate | date: 'MM/dd/yyyy' }}
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText [(ngModel)]="item.sellingPrice" placeholder="Enter Selling Price" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <span *ngIf="!item.sellingPrice" class="placeholder-text">Enter Selling Price</span>
                            <span *ngIf="item.sellingPrice">{{ item.sellingPrice | currency: 'USD':'symbol' }}</span>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText [(ngModel)]="item.costPrice" placeholder="Enter Cost Price" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <span *ngIf="!item.costPrice" class="placeholder-text">Enter Cost Price</span>
                            <span *ngIf="item.costPrice">{{ item.costPrice | currency: 'USD':'symbol' }}</span>
                        </ng-template>
                    </p-cellEditor>

                    <!--adding editable selling and cost price -->


                <td>{{ item.orderNumber ?? 'No Orders' }}</td>
                <td>{{ item.opportunityName ?? 'No Opportunity' }}</td>
                <td>{{ item.customerName ?? 'No Customer' }}</td>
                <td> <i class="pi" [ngStyle]="{ color: item.isLicense ? 'green' : 'red' }" [class.pi-check-circle]="item.isLicense" [class.pi-times-circle]="!item.isLicense"></i></td>
                <td alignFrozen="right" pFrozenColumn>

                    <p-button
                    icon="fa fa-history" class="mr-2" [rounded]="true"
                    [text]="true" pTooltip="History"
                    [hidden]="item.isLicense"
                    (onClick)="showItemsHistory(item.id)"></p-button>

                <p-button *ngIf="item.deliveryTicket != null"
                    icon="pi pi-ticket" [rounded]="true"
                    [text]="true"  pTooltip="View Dilevery" (onClick)="viewDeliveryTicket(item.id)" tooltipPosition="top"></p-button>

                </td>

            </tr>
        </ng-template>
    </p-table>
    <div class="dialog-footer">
        <p-button label="Cancel" icon="pi pi-times" (onClick)="closeItemsDialog()"></p-button>
        <p-button label="Save" icon="pi pi-check" (onClick)="saveOrderItems()"></p-button>
    </div>
</p-dialog>


<!-- History Dialog -->




<p-dialog header="Item History" [(visible)]="visibleitemsHistoryDialog" [modal]="true" [style]="{ width: '70vw' }">

    <p-table [value]="ItemsHistory"  [scrollable]="true" scrollHeight="800px"
    [resizableColumns]="true">

        <ng-template pTemplate="header">

            <tr>

                <th>#</th>
                <th>History Sequence</th>
                <th>HardWare Order Number</th>
                <th>License Order Number</th>
                <th>License Product</th>
                <th> Start Date </th>
                <th> End Date </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>



                <td>{{ i + 1 }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.hardwareNumberOrder }}</td>
                <td>{{ item.licenseNumberOrder }}</td>
                <td>
                    {{ (item.swCategory === 'No Category' && item.swType === 'No Type' && item.swItem === 'No Item')
                       ? '-' : (item.swCategory + ' - ' + item.swType + ' - ' + item.swItem) }}
                  </td>

                <td>{{ item.startDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ item.endDate | date: 'MM/dd/yyyy' }}</td>



            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="10" class="text-center">No History For This Item.</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="dialog-footer">
        <p-button label="Cancel" icon="pi pi-times" (onClick)="visibleitemsHistoryDialog = false"></p-button>
    </div>
</p-dialog>


<p-dialog header="Delivery Tickets" [(visible)]="showTicketsDialog" [modal]="true" [style]="{ width: '70vw' }" [maximizable]="true">
    <div class="flex justify-content-end mb-3">
        <!-- Edit and Save/Cancel buttons based on editMode -->
        <p-button
            *ngIf="!editMode"
            label="Edit"
            icon="pi pi-pencil"
            (onClick)="toggleEditMode()"
            class="mr-2">
        </p-button>
        <p-button
            *ngIf="editMode"
            label="Save"
            icon="pi pi-save"
            (onClick)="saveDeliveryTickets()"
            class="mr-2">
        </p-button>
        <p-button
            *ngIf="editMode"
            label="Cancel"
            icon="pi pi-times"
            (onClick)="toggleEditMode()"
            severity="secondary">
        </p-button>
    </div>

    <!-- Table for displaying Delivery Tickets -->
    <p-table [value]="editableDeliveryTickets" [scrollable]="true" scrollHeight="400px" [resizableColumns]="true" [editMode]="editMode ? 'row' : 'none'">
        <ng-template pTemplate="header">
            <tr>
                <th>#</th>
                <th>Title</th>
                <th>Created Date</th>
                <th>Delivery Date</th>
                <th>Receiver Name</th>
                <th>Receiver Contact</th>
                <th>Delivered By</th>
                <th>Delivery Text</th>
                <th>Order Number</th>
                <th>Movement State</th>
                <th>Delivered Quantity</th>
                <th *ngIf="!editMode" alignFrozen="right" pFrozenColumn>Actions</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-ticket let-i="rowIndex">
            <tr>
                <td>{{ i + 1 }}</td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.title"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.title }}</span>
                </td>
                <td>
                    <p-calendar
                        *ngIf="editMode"
                        [(ngModel)]="ticket.createdDate"
                        appendTo="body"
                        styleClass="full-width-calendar"
                        dateFormat="yy-mm-dd">
                    </p-calendar>
                    <span *ngIf="!editMode">{{ ticket.createdDate | date: 'MM/dd/yyyy' }}</span>
                </td>
                <td>
                    <p-calendar
                        *ngIf="editMode"
                        [(ngModel)]="ticket.deliveryDate"
                        appendTo="body"
                        styleClass="full-width-calendar"
                        dateFormat="yy-mm-dd">
                    </p-calendar>
                    <span *ngIf="!editMode">{{ ticket.deliveryDate | date: 'MM/dd/yyyy' }}</span>
                </td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.receiverName"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.receiverName }}</span>
                </td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.receiverContact"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.receiverContact }}</span>
                </td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.deliveredBy"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.deliveredBy }}</span>
                </td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.deliveryText"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.deliveryText }}</span>
                </td>
                <td>{{ ticket.orderNumber }}</td>
                <td>
                    <input
                        *ngIf="editMode"
                        [(ngModel)]="ticket.movementState"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.movementState }}</span>
                </td>
                <td>
                    <input
                        *ngIf="editMode"
                        type="number"
                        [(ngModel)]="ticket.deliveredQty"
                        pInputText
                        class="w-full">
                    <span *ngIf="!editMode">{{ ticket.deliveredQty }}</span>
                </td>
                <td alignFrozen="right" pFrozenColumn>
                    <!-- Show Serials button in non-edit mode -->
                    <p-button
                        *ngIf="!editMode"
                        icon="pi pi-eye"
                        class="mr-2"
                        [rounded]="true"
                        [text]="true"
                        (onClick)="fetchItemsSummary(ticket.id)"
                        pTooltip="Show Serials">
                    </p-button>
                </td>
            </tr>
        </ng-template>

        <!-- Empty message if no tickets available -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="12" class="text-center">No tickets found for this order.</td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Footer buttons -->
    <div class="dialog-footer">
        <p-button label="Close" icon="pi pi-times" (onClick)="showTicketsDialog = false; editMode = false;"></p-button>
    </div>
</p-dialog>



<!-- <td class="text-center">
    <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': customer.verified, 'text-red-500 pi-times-circle': !customer.verified }"></i>
</td> -->
<p-dialog header="New Delivery Ticket" [(visible)]="visibleNewDeliveryDialog" [modal]="true" [style]="{ width: '50vw' }">
    <form #deliveryTicketForm="ngForm" (ngSubmit)="createDeliveryTicket()">
        <div class="row">
          <!-- Column 1 -->
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label for="title">Title</label>
              <input
                id="title"
                type="text"
                class="form-control"
                pInputText
                [(ngModel)]="newDeliveryTicket.title"
                name="title"
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="createdDate">Created Date</label>
              <p-calendar
                id="createdDate"
                [(ngModel)]="newDeliveryTicket.createdDate"
                name="createdDate"
                required
                [showIcon]="true"
                class="full-width"
              ></p-calendar>
            </div>
            <div class="form-group mb-3">
              <label for="receiverName">Receiver Name</label>
              <input
                id="receiverName"
                type="text"
                class="form-control"
                pInputText
                [(ngModel)]="newDeliveryTicket.receiverName"
                name="receiverName"
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="movementState">Movement State</label>
              <input
                id="movementState"
                type="text"
                class="form-control"
                pInputText
                [(ngModel)]="newDeliveryTicket.movementState"
                name="movementState"
                required
              />
            </div>
          </div>

          <!-- Column 2 -->
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label for="deliveryDate">Delivery Date</label>
              <p-calendar
                id="deliveryDate"
                [(ngModel)]="newDeliveryTicket.deliveryDate"
                name="deliveryDate"
                required
                [showIcon]="true"
                class="full-width"
              ></p-calendar>
            </div>
            <div class="form-group mb-3">
              <label for="receiverContact">Receiver Contact</label>
              <input
                id="receiverContact"
                type="text"
                class="form-control"
                pInputText
                [(ngModel)]="newDeliveryTicket.receiverContact"
                name="receiverContact"
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="deliveredBy">Delivered By</label>
              <input
                id="deliveredBy"
                type="text"
                class="form-control"
                pInputText
                [(ngModel)]="newDeliveryTicket.deliveredBy"
                name="deliveredBy"
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="deliveredQty">Delivered Quantity</label>
              <p-inputNumber
                id="deliveredQty"
                [(ngModel)]="newDeliveryTicket.deliveredQty"
                name="deliveredQty"
                required
                class="full-width"
              ></p-inputNumber>
            </div>
          </div>
        </div>

        <!-- Full-Width Row for Delivery Text -->
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="deliveryText">Delivery Text</label>
              <textarea
                id="deliveryText"
                class="form-control"
                pInputTextarea
                [(ngModel)]="newDeliveryTicket.deliveryText"
                name="deliveryText"
                required
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="dialog-footer mt-3">
          <button
            type="button"
            pButton
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            (click)="visibleNewDeliveryDialog = false"
          ></button>
          <button
            type="submit"
            pButton
            label="Save"
            icon="pi pi-check"
          ></button>
        </div>
      </form>



  </p-dialog>

  <p-dialog header="Delivery Ticket Details" [(visible)]="visibleDeliveryTicketDialog" [modal]="true" [style]="{ width: '70vw' }">
    <p-table [value]="[deliveryTicket]" [scrollable]="true" scrollHeight="400px" [resizableColumns]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Title</th>
                <th>Created Date</th>
                <th>Delivery Date</th>
                <th>Receiver Name</th>
                <th>Receiver Contact</th>
                <th>Delivered By</th>
                <th>Movement State</th>
                <th>Delivered Quantity</th>
                <th>Delivery Text</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ticket>
            <tr>
                <td><input type="text" pInputText  [(ngModel)]="deliveryTicket.title" readonly/></td>
                <td><input type="date" pInputText  [(ngModel)]="deliveryTicket.createdDate" readonly/></td>
                <td><input type="date" pInputText   [(ngModel)]="deliveryTicket.deliveryDate" readonly/></td>
                <td><input type="text" pInputText  [(ngModel)]="deliveryTicket.receiverName" readonly/></td>
                <td><input type="text"pInputText  [(ngModel)]="deliveryTicket.receiverContact" readonly/></td>
                <td><input type="text" pInputText  [(ngModel)]="deliveryTicket.deliveredBy" readonly/></td>
                <td><input type="text"pInputText  [(ngModel)]="deliveryTicket.movementState" readonly/></td>

                <td><p-inputNumber type="number"  [(ngModel)]="deliveryTicket.deliveredQty" readonly/></td>
                <td><textarea rows="2"  [(ngModel)]="deliveryTicket.deliveryText"></textarea></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="9" class="text-center">No delivery ticket details available.</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="dialog-footer">
        <p-button label="Close" icon="pi pi-times" (onClick)="visibleDeliveryTicketDialog = false"></p-button>
    </div>
</p-dialog>

<p-dialog
    header="Item Summary"
    [(visible)]="showItemsSummaryDialog"
    [modal]="true"
    [style]="{ width: '60vw' }"
    [maximizable]="true">

    <p-table [value]="itemsSummary" [scrollable]="true" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th>#</th>
                <th>Serial Number</th>
                <th>Product Category</th>
                <th>Product Type</th>
                <th>Product Item</th>

                <th>Coverage Start Date</th>
                <th>Coverage End Date</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ item.serialNumber }}</td>
                <td>{{ item.productCategory }}</td>
                <td>{{ item.productType }}</td>
                <td>{{ item.productItem }}</td>

                <td>{{ item.coverageStartDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ item.coverageEndDate | date: 'MM/dd/yyyy' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center">No items found for this delivery ticket.</td>
            </tr>
        </ng-template>
    </p-table>

    <div class="dialog-footer">
        <p-button label="Close" icon="pi pi-times" (onClick)="showItemsSummaryDialog = false"></p-button>
    </div>
</p-dialog>


